var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckinSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 11.1517V4.16675H11.151V6.26071H6.25997V11.1517H4.16602ZM4.16602 35.8333V28.8483H6.25997V33.7394H11.151V35.8333H4.16602ZM28.8476 35.8333V33.7394H33.7386V28.8483H35.8326V35.8333H28.8476ZM33.7386 11.1517V6.26071H28.8476V4.16675H35.8326V11.1517H33.7386ZM28.8593 28.8878H31.1809V31.2094H28.8593V28.8878ZM28.8593 24.2447H31.1809V26.5662H28.8593V24.2447ZM26.5484 26.5662H28.8593V28.8878H26.5484V26.5662ZM24.2269 28.8878H26.5484V31.2094H24.2269V28.8878ZM21.9053 26.5662H24.2269V28.8878H21.9053V26.5662ZM26.5484 21.9231H28.8593V24.2447H26.5484V21.9231ZM24.2269 24.2447H26.5484V26.5662H24.2269V24.2447ZM21.9053 21.9231H24.2269V24.2447H21.9053V21.9231ZM31.1809 8.79071V18.077H21.9053V8.79071H31.1809ZM18.0762 21.9231V31.2094H8.78997V21.9231H18.0762ZM18.0762 8.79071V18.077H8.78997V8.79071H18.0762ZM16.2921 29.4253V23.7073H10.5741V29.4253H16.2921ZM16.2921 16.2928V10.5748H10.5741V16.2928H16.2921ZM29.3967 16.2928V10.5748H23.6895V16.2928H29.3967Z",
    fill: "#006CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckinSelected);
export default __webpack_public_path__ + "static/media/checkin_selected.3bd34a82d0c630f06de8da481ad307ed.svg";
export { ForwardRef as ReactComponent };